export const PAYMENT_SWITCH_CONFIRM_CONTENT =
  "This will change the existing payment mode.Do you want to proceed?";
export const PAYMENT_SWITCH_CONFIRM_TITLE = "Payment mode confirmation";

export enum PaymentMode {
  OPEN_EDGE = "OPENEDGE",
  STAX = "STAX",
  CYBERSOURCE = "CYBERSOURCE",
}
export const API_PREFIX = "api";
